import configOptions from './configOptions';
import FolderTreeType from 'mini-mail-folder-store/lib/store/schema/FolderTreeType';
import toggleFolderTreeExpansion from 'mini-mail-folder-store/lib/actions/toggleFolderTreeExpansion';
import { configDirection } from '../schema/handleKeyArrowPressDeclarations';
import { handleArrowKeyPressConfig } from '../schema/handleKeyArrowPressDeclarations';
import { KeyboardCharCodes } from 'mini-hotkeys/lib/schema/KeyboardCharCodes';
import { trySetFocusOnElement } from 'dom-utils/lib/utils/focusUtils';

//This util is used to provide keyboard / arrow key based movement to Shoreline
const handleArrowKeyPress = (keyConfig: handleArrowKeyPressConfig) => event => {
    const {
        itemIndex,
        itemRefs,
        length,
        rootNode,
        folderTreeType,
        onRootNodeClicked,
        onSelect,
    } = keyConfig;

    if (event.key !== 'Enter' && event.key !== 'Tab' && !event.shiftKey) {
        event.preventDefault();
    }

    if (event.key == 'Enter' && onSelect) {
        onSelect();
        return;
    }

    if (rootNode) {
        if (event.keyCode == KeyboardCharCodes.Enter) {
            if (folderTreeType != FolderTreeType.Default) {
                toggleFolderTreeExpansion(folderTreeType);
                return;
            } else {
                onRootNodeClicked();
            }
        }
    }
    //Depending on the current condition, the appropriate next index is shifted to. The conditions are elaborated more in the function configDirection
    if (event.keyCode == KeyboardCharCodes.Up_arrow) {
        if (itemIndex == 0) {
            trySetFocusOnElement(itemRefs[length - 1].current);
        } else {
            const {
                condition,
                conditionMet,
                conditionUnMet,
                secondCondition,
                secondConditionMet,
                secondConditionUnMet,
                thirdCondition,
                thirdConditionMet,
                thirdConditionUnMet,
            } = configDirection(keyConfig, configOptions(), true);
            if (secondCondition == null) {
                trySetFocusOnElement(condition ? conditionMet.current : conditionUnMet.current);
            } else if (thirdCondition == null) {
                trySetFocusOnElement(
                    condition
                        ? conditionMet.current
                        : secondCondition
                        ? secondConditionMet.current
                        : secondConditionUnMet
                );
            } else {
                trySetFocusOnElement(
                    condition
                        ? conditionMet.current
                        : secondCondition
                        ? thirdCondition
                            ? thirdConditionMet.current
                            : thirdConditionUnMet.current
                        : secondConditionUnMet.current
                );
            }
        }
    } else if (event.keyCode == KeyboardCharCodes.Down_arrow) {
        const {
            condition,
            conditionMet,
            conditionUnMet,
            secondCondition,
            secondConditionMet,
            thirdCondition,
            thirdConditionMet,
            thirdConditionUnMet,
        } = configDirection(keyConfig, configOptions(), false);
        if (secondCondition == null) {
            trySetFocusOnElement(condition ? conditionMet.current : conditionUnMet.current);
        } else
            trySetFocusOnElement(
                condition
                    ? secondCondition
                        ? secondConditionMet.current
                        : thirdCondition
                        ? thirdConditionMet.current
                        : thirdConditionUnMet.current
                    : conditionUnMet.current
            );
    }
};

export default handleArrowKeyPress;
